import { useSuspenseQuery } from '../../../services'
import { HITLIntegrationNotEnabledError } from '../errors'
import { getHITLClient } from '../../../stores'

type UseHitlClientParams = {
  botId: string
  workspaceId: string
}

export const useSuspenseHITLClient = ({ botId, workspaceId }: UseHitlClientParams) => {
  const bot = useSuspenseQuery('workspaces_/$workspaceId_/bots_/$botId_', {
    workspaceId,
    botId,
  }).data
  const integrationsByName = Object.entries(bot.integrations).map(([intId, int]) => ({ ...int, id: intId }))
  const hitlIntegration = integrationsByName.find((int) => int.name === 'hitl')

  if (!hitlIntegration || !hitlIntegration.enabled) {
    throw new HITLIntegrationNotEnabledError()
  }

  const userKey = useSuspenseQuery('workspaces_/$workspaceId_/bots_/$botId_/hitl/$webhookId/userKey', {
    workspaceId,
    botId,
    webhookId: hitlIntegration.webhookId,
  }).data

  const { webhookId } = hitlIntegration

  return getHITLClient({ userKey, webhookId })
}
